import { Skeleton } from 'antd';

export const Loading = () => {
	return (
		<div className="loading">
			<Skeleton avatar={{ size: 30 }} active paragraph={{ rows: 3, width: '50%' }} title={false} />
		</div>
	);
};
